import React from 'react';
import { JuniorHubScreen } from '../../components/home/JuniorHubScreen';
import { ESCUCHAR_ITEMS } from '../../lib/juniorTheme';

export default function EscucharHubPage() {
  return (
    <JuniorHubScreen
      eyebrow="Escuchar"
      title="Oído musical"
      subtitle="Escucha, identifica y describe sonidos del mundo musical."
      emoji="👂"
      accent="sky"
      items={ESCUCHAR_ITEMS}
    />
  );
}
